import React from 'react';
import { Link } from '@grubhubprod/gh-cookbook-react';
import { RouterLink } from 'src/components/RouterLink/RouterLink';

interface ICustomLinkProps {
  href: string;
  label: string;
  useRouterLink?: boolean;
}

export function CustomLink({
  href,
  label,
  useRouterLink,
}: ICustomLinkProps): JSX.Element {
  if (useRouterLink) {
    return <RouterLink href={href}>{label}</RouterLink>;
  }
  return <Link href={href}>{label}</Link>;
}
